import { NavigateBackLink } from '@exam-center/components';
import { EKycVerificationStatus } from '@exam-center/graphql';
import { EKYC_STATUS_COLOR, EKYC_STATUS_TEXT } from '@exam-center/proctoring-ekyc-list';
import { useProctoringEKycVerification } from '@exam-center/proctoring-ekyc-verification';
import { Label, PageHeader } from '@shared/components';

export default function ProctoringUserDetailsPageHeader() {
  const { examCenterCode, examEventId, eKycInfo, loading } = useProctoringEKycVerification();
  const { title, firstName, lastName, status } = eKycInfo;

  return (
    <PageHeader
      title={`${title} ${firstName} ${lastName}`}
      linkAdornment={
        <NavigateBackLink
          to='/:examCenterCode/proctoring/exam-events/:examEventId/e-kyc'
          params={{
            examCenterCode: examCenterCode,
            examEventId: examEventId,
          }}
          label='Back'
        />
      }
      endAdornment={(() => {
        const statusKey = status as keyof typeof EKYC_STATUS_COLOR;
        const labelColor = EKYC_STATUS_COLOR[statusKey];
        if (loading || status === EKycVerificationStatus.Approved) {
          return null;
        }
        return (
          <Label variant='outlined' color={labelColor} size='large'>
            {EKYC_STATUS_TEXT[status]}
          </Label>
        );
      })()}
    />
  );
}
